/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Edit Types
 *
 * Part I, Section 26
 */
export enum EditType {
    MainAsset = 'Main Asset',
    ShorterOrLongerVersion = 'Shorter Or Longer Version',
    PermittedChanges = 'Permitted Changes',
    PaidEdits = 'Paid Edits',
    AddressableEdits = 'Addressable Edits',
}
